import React, { useEffect, useState } from 'react'

export const ModalForm = ({ isOpen, onClose, mode, OnSubmit, clientData }) => {
  const [rate, setRate] = useState('')
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [job, setJob] = useState('')
  const [status, setStatus] = useState(false)
  const [errors, setErrors] = useState({})

  const handleStatusChange = (event) => {
    setStatus(event.target.value === 'Active')
  }

  const handleClose = () => {
    setErrors({})
    setName('')
    setEmail('')
    setJob('')
    setRate('')
    setStatus(false)
    onClose()
  }

  const validateForm = () => {
    const newErrors = {}
    if (!name.trim()) newErrors.name = 'Name is required'
    if (!email.trim()) newErrors.email = 'Email is required'
    if (!job.trim()) newErrors.job = 'Job is required'
    if (!rate.trim()) newErrors.rate = 'Rate is required'

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async (event) => {
    event.preventDefault()

    if (!validateForm()) {
      return
    }

    try {
      const clientData = {
        name,
        email,
        job,
        rate: Number(rate),
        isactive: status,
      }
      await OnSubmit(clientData)
      handleClose()
    } catch (error) {
      console.error('Error adding client:', error)
    }
  }

  // Reset form when modal opens/closes
  useEffect(() => {
    if (!isOpen) {
      setErrors({})
      setName('')
      setEmail('')
      setJob('')
      setRate('')
      setStatus(false)
    }
  }, [isOpen])

  // Set form data when in edit mode
  useEffect(() => {
    if (mode === 'edit' && clientData) {
      setName(clientData.name)
      setEmail(clientData.email)
      setJob(clientData.job)
      setRate(clientData.rate)
      setStatus(clientData.isactive)
    }
  }, [mode, clientData])

  return (
    <div>
      <dialog id="my_modal_3" className="modal" open={isOpen}>
        <div className="modal-box">
          <h3 className="font-bold text-lg py-4">
            {mode === 'edit' ? 'Edit Client' : 'Client Details'}
          </h3>
          <form method="dialog" onSubmit={handleSubmit}>
            <button
              type="button"
              className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
              onClick={handleClose}
            >
              ✕
            </button>

            {/* =========================================== */}
            <label className="input input-bordered my-4 flex items-center gap-2 w-full">
              Name
              <input
                type="text"
                className={`grow ${errors.name ? 'border-red-500' : ''}`}
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </label>
            {errors.name && (
              <p className="text-red-500 text-sm -mt-3">{errors.name}</p>
            )}

            <label className="input input-bordered my-4 flex items-center gap-2 w-full">
              Email
              <input
                type="text"
                className={`grow ${errors.email ? 'border-red-500' : ''}`}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </label>
            {errors.email && (
              <p className="text-red-500 text-sm -mt-3">{errors.email}</p>
            )}

            <label className="input input-bordered my-4 flex items-center gap-2 w-full">
              Job
              <input
                type="text"
                className={`grow ${errors.job ? 'border-red-500' : ''}`}
                value={job}
                onChange={(e) => setJob(e.target.value)}
              />
            </label>
            {errors.job && (
              <p className="text-red-500 text-sm -mt-3">{errors.job}</p>
            )}

            <div className="flex mb-4 justify-between my-4">
              <label className="input input-bordered mr-4 flex items-center gap-2">
                Rate
                <input
                  type="text"
                  className={errors.rate ? 'border-red-500' : ''}
                  value={rate}
                  onChange={(e) => setRate(e.target.value)}
                />
              </label>
              {errors.rate && (
                <p className="text-red-500 text-sm -mt-3">{errors.rate}</p>
              )}

              <select
                value={status ? 'Active' : 'Inactive'}
                onChange={handleStatusChange}
                className="select select-bordered w-full max-w-xs"
              >
                <option>Inactive</option>
                <option>Active</option>
              </select>
            </div>
            {/* =========================================== */}

            <button type="submit" className="btn btn-success">
              {mode === 'edit' ? 'Save Changes' : 'Add Client'}
            </button>
          </form>
        </div>
      </dialog>
    </div>
  )
}
